import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const ProxyUsage: React.FC = () => {
  return (
    <Box>
      <Typography variant="h4" gutterBottom sx={{ fontWeight: 700, mb: 3 }}>
        Proxy Usage
      </Typography>
      <Paper sx={{ p: 3 }}>
        <Typography variant="body2" color="text.secondary">
          Proxy usage statistics and monitoring will be displayed here.
        </Typography>
      </Paper>
    </Box>
  );
};

export default ProxyUsage;

